import "./nokkers.scss"

export default function Nokkers() {
    return (
        <div className="nokkers">
            <div className="nokkersContent">
                <div className="nokkersLeft">
                    <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>Retroactrive Drops</h2>
                        </div>
                        <div className="postDesc">
                            <p>You will receive NFT and token drops from participating on the NOK platforms.</p>
                        </div>
                    </div>
                    <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>PV System</h2>
                        </div>
                        <div className="postDesc">
                            <p>Our Patent Persistent value system ensures that the price of NOK only keeps going higher without pause.</p>
                        </div>
                    </div>
                    <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>Lifetime Royalty</h2>
                        </div>
                        <div className="postDesc">
                            <p>Earn commissions on your minted NFT every time someone buys it.</p>
                        </div>
                    </div>

                </div>
                <div className="nokkersRight">
                <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>NOK Games</h2>
                        </div>
                        <div className="postDesc">
                            <p>Hunt for treasure and hidden NOK heads in our mobile, desktop and VR games.</p>
                        </div>
                    </div>
                    <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>Integration</h2>
                        </div>
                        <div className="postDesc">
                            <p>Trade NOK NFT on other marketplaces by integrating smart contract on the platform.</p>
                        </div>
                    </div>
                    <div className="nokkersPost">
                        <div className="postTitle">
                            <h2>NFT Integration</h2>
                        </div>
                        <div className="postDesc">
                            <p>Integrate NOK NFT with other NFT platforms so you can sell and trade your NOK on their marketplace.</p>
                        </div>
                    </div>

                </div>
            </div>
            
        </div>
    )
}
